export default __webpack_public_path__ + "static/media/portfolio-cai-6.30b0b3df.jpg";